import { authHeader, clearStorage } from '../_helpers'
import axios from 'axios'

export default (to, from, next) => {
  axios.get(`/back-office/verify-token`, authHeader())
    .then(() => {
      next()
    })
    .catch(() => {
      clearStorage('_admin')
      next({ name: 'login' })
    })
}